import api from "@/services/api";

export default {
  fetchPrograms() {
    return api.get(`program/`).then(response => response.data);
  },
  getProgramStakeholdersWithSurveys(pk) {
    api.defaults.timeout = 30000
    return api.get(`program/get_program_stakeholders_and_surveys/?pk=${pk}`)
  },
  getProgramConversations(pk) {
    api.defaults.timeout = 30000
    return api.get(`program/get_program_conversations/?pk=${pk}`)
  },
  updateProgram(payload) {
    return api.patch(`program/${payload.pk}/`, payload).then(response => response.data);
  },
};
